import { render, staticRenderFns } from "./ClicCatalog.vue?vue&type=template&id=2b6f3360&"
import script from "./ClicCatalog.vue?vue&type=script&lang=js&"
export * from "./ClicCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ClicCatalog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports